

function EditApiAppWindow({isOpenWindow, onCloseWindow, apiAppId}) {

    return (<></>);
}

export default EditApiAppWindow;